import { Button, DatePicker, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	addSingleTask,
	loadAllTask,
	loadAllTaskPaginated,
	updateTask,
} from "../../../redux/rtk/features/crm/task/crmTaskSlice";
import { toast } from "react-toastify";

export default function CreateTaskForm({ onClose, createAs, total, editData }) {
	const [isEditing, setIsEditing] = useState(false)
	const [form] = Form.useForm();
	const getNextId = (data) => {
		const ids = data?.map((_) => _.slotId);
		if (!ids?.length) {
			form.setFieldsValue({
				slotId: 1
			});
			return;
		}
		const maxId = Math.max(...ids);
		console.log("setting :: ", maxId);

		form.setFieldsValue({
			slotId: maxId + 1 // Set value directly in the form
		});
	}

	useEffect(() => {
		if (editData) {
			setIsEditing(true)
			form.setFieldsValue({
				slotId: editData.id,
				taskName: editData.taskName,
				slotCostEnd: editData.slotCostEnd,
				slotCostWeek: editData.slotCostWeek
			})
		}
		else {
			(async () => {
				const data = await dispatch(loadAllTaskPaginated({ status: true, page: 1, count: 10 }));
				getNextId(data.payload)
			})()
		}
	}, [editData, form]);
	const dispatch = useDispatch();
	// selector
	const { list: companyList, loading: companyLoading } = useSelector(
		(state) => state.company
	);
	const { list: contactList, loading: contactLoading } = useSelector(
		(state) => state.contact
	);
	const { list: quoteList, loading: quoteLoading } = useSelector(
		(state) => state.quote
	);
	const { list: opportunityList, loading: opportunityLoading } = useSelector(
		(state) => state.opportunity
	);

	const { list: taskPriorityList, loading: taskPriorityLoading } = useSelector(
		(state) => state.crmTaskPriority
	);
	const { list: taskTypeList, loading: taskTypeLoading } = useSelector(
		(state) => state.crmTaskType
	);
	const { list: taskStatusList, loading: taskStatusLoading } = useSelector(
		(state) => state.crmTaskStatus
	);
	const { list: staffList, loading: staffLoading } = useSelector(
		(state) => state.users
	);
	const { addingTask } = useSelector((state) => state.crmTask);



	const onFinish = async (values) => {
		try {
			if (isEditing) {
				console.log("editing :: ")
				const formData = {
					slotCostEnd: parseInt(values.slotCostEnd),
					slotCostWeek: parseInt(values.slotCostWeek)
				};

				const resp = await dispatch(updateTask({ id: editData.id, values: formData }));
				toast.success("Slot Created Successfully")
				dispatch(loadAllTaskPaginated({ status: true, page: 1, count: 10 }));
				onClose();
				// form.resetFields();
			}
			else {
				const formData = {
					...values,
					slotId: values.slotId,
					slotCostEnd: parseInt(values.slotCostEnd),
					slotCostWeek: parseInt(values.slotCostWeek)
				};

				const resp = await dispatch(addSingleTask(formData));
				toast.success("Slot Created Successfully")
				form.resetFields();
				onClose();
			}

		} catch (error) {
			console.error(error)
		}

	};

	const onCancel = () => {
		form.resetFields();
		onClose();
	};

	const onFinishFailed = (errorInfo) => {
		console.log("Failed:", errorInfo);
	};

	return (
		<div className='flex justify-center mt-5'>
			<Form
				className='w-4/5'
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				colon={false}
				layout='vertical'
				form={form}
				initialValues={
					createAs
						? {
							[createAs.name]: createAs.value,
						}
						: {}
				}>
				<Form.Item
					style={{ width: "100%" }}
					label='Slot Time'
					disabled={isEditing}
					name='taskName'
					tooltip='This is a required field'
					rules={[{ required: true, message: "Slot Time is Required." }]}>
					<Input placeholder='11:00 - 12:00' disabled={isEditing}/>
				</Form.Item>
				<Form.Item
					style={{ width: "100%" }}
					label='Slot No'
					name='slotId'
					tooltip='This is a required field'

				>
					<Input placeholder={total + 1} 	disabled={isEditing} />
				</Form.Item>
				<Form.Item
					style={{ width: "100%" }}
					label='Slot Cost Week Days'
					name='slotCostWeek'
					tooltip='This is a required field'
					rules={[{ required: true, message: "Slot Cost Week Days is Required." }]}>
					<Input placeholder='Slot Cost Week Days' />
				</Form.Item>
				<Form.Item
					style={{ width: "100%" }}
					label='Slot Cost Weekend '
					name='slotCostEnd'
					tooltip='This is a required field'
					rules={[{ required: true, message: "Slot Cost Weekend is Required." }]}>
					<Input placeholder='Slot Cost Weekend ' />
				</Form.Item>
				<div className='w-[726.4px]'>
					<Form.Item label=''>
						<div className='flex items-center gap-2'>
							<Button
								size={"large"}
								htmlType='submit'
								type='primary'
								loading={addingTask}>
								{isEditing ? "Update" : "Create"}
							</Button>
							<Button size={"large"} type='danger' onClick={onCancel}>
								Cancel
							</Button>
						</div>
					</Form.Item>
				</div>
			</Form>
		</div>
	);
}
